import Utils from '@/utils/util';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { ReactComponent as DecrementIcon } from '@/assets/img/decrement.svg';
import { ReactComponent as IncrementIcon } from '@/assets/img/increment.svg';

type DefaultValues = {
  step: number;
  maxHours: number;
};
export type DurationPickerProps = {
  selectedDuration: number;
  onSelectDuration: (item: any) => void;
  defaultValues?: DefaultValues;
  disableConversion?: boolean;
  disabled?: boolean;
};

const STEP = 5;
const MAX_HRS = 120;

export const DurationPicker = ({
  selectedDuration,
  onSelectDuration,
  defaultValues,
  disableConversion,
  disabled
}: DurationPickerProps) => {
  const [duration, setDuration] = useState(selectedDuration);
  const [step, setStep] = useState(defaultValues ? defaultValues.step : STEP);
  const [maxHours, setMaxHours] = useState(defaultValues ? defaultValues.maxHours : MAX_HRS);
  

  useEffect(() => {
    if (defaultValues) {
      setStep(defaultValues.step);
      setMaxHours(defaultValues.maxHours);
    }
  }, [defaultValues]);

  const incrementDuration = () => {
    setDuration(duration + step);
  };

  const decrementDuration = () => {
    if (duration >= step) {
      setDuration(duration - step);
    }
  };

  useEffect(() => setDuration(selectedDuration), [selectedDuration]);

  useEffect(() => {
    if (duration) {
      onSelectDuration(duration);
    }
  }, [duration]);

  return (
    <div className="duration-picker">
      <button
        disabled={duration <= step || disabled }
        className="duration-picker-btn"
        onClick={decrementDuration}
      >
        <DecrementIcon />
      </button>
      <div className="duration">
        {disableConversion ? duration : Utils.getDuration(duration)}
      </div>
      <button
        disabled={duration >= maxHours || disabled }
        className="duration-picker-btn"
        onClick={incrementDuration}
      >
        <IncrementIcon />
      </button>
    </div>
  );
};
